import type { ReactNode } from "react"
import { MARKV_TRACE_SIZE, MarkVTraceLoader } from "@/components/compass/MarkVTraceLoader"
import { cn } from "@/lib/cn"

/*
 * MARK V — espera inline. Loader Traço + texto, numa linha só.
 *
 * Este wrapper é quem ANUNCIA (role="status" + aria-live). O svg fica
 * decorativo de propósito: se os dois falassem, o leitor de tela leria
 * "Carregando Carregando categorias". Regra geral do Traço: o primitivo nunca
 * abre live region, só os wrappers de contexto.
 *
 * Use em linha de drill-down, popover e qualquer espera pontual que já tenha
 * texto ao lado. Para espera que cobre uma área inteira, use LoadingOverlay.
 */

export type LoadingRowProps = {
  /** Texto anunciado. Sem children, anuncia "Carregando". */
  children?: ReactNode
  /** Lado do loader em px. Default 32 (escala de linha). */
  size?: number
  className?: string
}

export function LoadingRow({ children, size = MARKV_TRACE_SIZE.inline, className }: LoadingRowProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      data-testid="loading-row"
      className={cn("inline-flex items-center gap-3 text-sm text-markv-text-400", className)}
    >
      <MarkVTraceLoader size={size} label="" />
      <span>{children ?? "Carregando"}</span>
    </span>
  )
}
